import { parseFileFieldValue } from "@/utils/entityFieldsUtils/fileFieldUtils";
import { getColumnRawValue } from "./monthGrouping";

/**
 * Two buckets for grouping by a file column. Each row holds its own list of
 * attachments, so grouping on the raw value gives one group per row; a column that
 * opts in through `meta.groupByFilePresence` groups on whether it holds a file.
 */

export const isFilePresenceGroupedColumn = (meta: unknown): boolean =>
  Boolean(
    (meta as { groupByFilePresence?: boolean } | undefined)?.groupByFilePresence
  );

export const HAS_FILE_GROUP_KEY = "hasFile";
export const NO_FILE_GROUP_KEY = "noFile";

export const toFilePresenceGroupKey = (value: unknown): string =>
  parseFileFieldValue(value).length > 0
    ? HAS_FILE_GROUP_KEY
    : NO_FILE_GROUP_KEY;

/**
 * Ranks rows with a file ahead of rows without. A descending sort on the grouped
 * column reverses the group order, as it does for every ranked grouping.
 */
export const filePresenceGroupRank =
  (column: unknown) =>
  (row: unknown): number =>
    toFilePresenceGroupKey(getColumnRawValue(column, row)) ===
    HAS_FILE_GROUP_KEY
      ? 0
      : 1;
